import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import styles from 'stylesheets/components/tooltip.module';

export function Tooltip(props) {
  const dataClassNames = props.textSize === 'large' ? classNames(styles.tooltip, styles.largeText) : styles.tooltip;
  return (
    <div
      className={styles.tooltipWrapper}
      data-tooltip-content={props.text}
      id={props.id}
      data-tooltip-delay-show={props.delayShow}
      data-tooltip-place={props.placement}
    >
      {props.children}
      <ReactTooltip anchorId={props.id} className={dataClassNames} />
    </div>
  );
}

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  delayShow: PropTypes.number,
  textSize: PropTypes.oneOf(['small', 'large']),
};

Tooltip.defaultProps = {
  placement: 'top',
  textSize: 'small',
};
